import { useNavigate } from "react-router-dom";

function CartPanel({
  cart,
  showCart,
  openCart,
  closeCart,
  closeCartWithDelay,
  totalItems,
  totalPrice,
  increaseQuantity,
  decreaseQuantity,
  removeItem,
}) {
  const navigate = useNavigate();

  const panelWidth = 340;
  const handleWidth = 48;
  const closedTranslate = panelWidth;

  return (
    <div
      style={{
        position: "fixed",
        top: "90px",
        right: "20px",
        display: "flex",
        alignItems: "flex-start",
        zIndex: 1000,
        transform: showCart
          ? "translateX(0)"
          : `translateX(${closedTranslate}px)`,
        transition: "transform 0.4s ease",
      }}
    >
      <button
        onClick={openCart}
        style={{
          marginTop: "20px",
          width: `${handleWidth}px`,
          height: "52px",
          background: "#111827",
          color: "white",
          border: "none",
          borderTopLeftRadius: "14px",
          borderBottomLeftRadius: "14px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "14px",
          boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
          flexShrink: 0,
        }}
      >
        🛒 {totalItems}
      </button>

      <div
        onMouseEnter={openCart}
        onMouseLeave={closeCartWithDelay}
        onClick={(e) => e.stopPropagation()}
        style={{
          width: `${panelWidth}px`,
          background: "rgba(255,255,255,0.82)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          border: "1px solid rgba(255,255,255,0.45)",
          borderRadius: "18px",
          borderTopLeftRadius: "0",
          padding: "22px",
          boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
          maxHeight: "80vh",
          overflowY: "auto",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #e5e7eb",
            paddingBottom: "12px",
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h2
              style={{
                margin: "0 0 5px 0",
                color: "#111",
              }}
            >
              Your Cart
            </h2>

            <p
              style={{
                margin: 0,
                color: "#666",
                fontSize: "14px",
              }}
            >
              {totalItems} item{totalItems !== 1 ? "s" : ""}
            </p>
          </div>

          <button
            onClick={closeCart}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              color: "#555",
              fontWeight: "bold",
            }}
          >
            ✕
          </button>
        </div>

        {cart.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "30px 10px",
              color: "#777",
            }}
          >
            <p style={{ marginBottom: "8px", fontSize: "16px" }}>
              Cart is empty
            </p>
            <p style={{ margin: 0, fontSize: "14px" }}>
              Add products to see them here
            </p>
          </div>
        ) : (
          <div>
            {cart.map((item) => (
              <div
                key={item.id}
                style={{
                  border: "1px solid rgba(229,231,235,0.8)",
                  borderRadius: "12px",
                  padding: "12px",
                  marginBottom: "12px",
                  backgroundColor: "rgba(255,255,255,0.45)",
                }}
              >
                <p
                  style={{
                    margin: "0 0 10px 0",
                    fontWeight: "600",
                    color: "#222",
                  }}
                >
                  {item.name}
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "8px",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <button
                      onClick={() => decreaseQuantity(item.id)}
                      style={{
                        width: "30px",
                        height: "30px",
                        border: "none",
                        borderRadius: "6px",
                        background: "#e5e7eb",
                        cursor: "pointer",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      -
                    </button>

                    <span
                      style={{
                        fontWeight: "bold",
                        minWidth: "30px",
                        textAlign: "center",
                      }}
                    >
                      {item.quantity}
                    </span>

                    <button
                      onClick={() => increaseQuantity(item.id)}
                      style={{
                        width: "30px",
                        height: "30px",
                        border: "none",
                        borderRadius: "6px",
                        background: "#d1fae5",
                        cursor: "pointer",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      +
                    </button>
                  </div>

                  <button
                    onClick={() => removeItem(item.id)}
                    style={{
                      background: "#ef4444",
                      color: "white",
                      border: "none",
                      padding: "6px 10px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Remove
                  </button>
                </div>

                <p
                  style={{
                    margin: 0,
                    color: "#111",
                    fontWeight: "bold",
                  }}
                >
                  ₹{item.price * item.quantity}
                </p>
              </div>
            ))}
          </div>
        )}

        <div
          style={{
            marginTop: "20px",
            paddingTop: "16px",
            borderTop: "1px solid #e5e7eb",
          }}
        >
          <h3
            style={{
              margin: "0 0 14px 0",
              color: "#111",
            }}
          >
            Total: ₹{totalPrice}
          </h3>

          <button
            onClick={() => {
              closeCart();
              navigate("/checkout");
            }}
            style={{
              width: "100%",
              background: "#111827",
              color: "white",
              border: "none",
              padding: "12px",
              borderRadius: "10px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Checkout
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartPanel;